import { SelectOption } from 'components/SelectInput/SelectInput'

export function SelectOptionAdapter<T extends string>(value: T, label: T) {
  const buildOption = (item: { [key in T]: string | number }): SelectOption => ({
    label: item[label] ? item[label].toString() : " ",
    //label: item[label].toString(),
    value: item[value],
  })


  const buildOptions = (items: Array<{ [key in T]: string | number }>): SelectOption[] =>
    items.map((item) => buildOption(item))

  return {
    buildOption,
    buildOptions,
  }
}

// Simple options are those in which label and value are the same and thus, the input is not an object
export function buildSimpleOption(value: string | number): SelectOption {
  return {
    label: value.toString(),
    value,
  }
}

export function buildSimpleOptions(values: Array<string | number>): SelectOption[] {
  return values.map((value) => buildSimpleOption(value))
}
